import { render } from "./TermsAndCondition.vue?vue&type=template&id=32234f55"
import script from "./TermsAndCondition.vue?vue&type=script&lang=js"
export * from "./TermsAndCondition.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xampp\\htdocs\\bdroyelfrontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__